import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { useLocation } from "react-router";
import { wxOtherLinkData } from "../wxLayout/linkData";
import { Button, Drawer, AdvancedLink, KzLogo } from "@/components";
import LayoutHeader from "@/components/LayoutHeader";
import LinksNav from "@/components/LayoutHeader/LinksNav";
import { getUserInfo } from "@/request/common";
import {
  URL_REGISTER_WAP,
  URL_REGISTER_PC,
  URL_LOGIN_WAP,
  URL_LOGIN_PC,
  URL_LOGOUT_PC,
  URL_LOGOUT_WAP,
} from "@/constants/wxHomepage";
import { Dialog } from "@kzui/core";
import { genBlock } from "@/utils/bem";
import { diffEndJump } from "@/utils/tools";
import CustomerServiceLeft from "@/assets/images/km/indexpage-customer-service/customer-service-left.png";
import CustomerServiceRight from "@/assets/images/km/indexpage-customer-service/customer-service-right.jpg";
import hsyQrcodeImg from "@/assets/images/kz-consult-qrcode.png";
import "@/assets/common.less";
import "./index.less";

interface LayoutProps {
  layoutData?: any;
  children?: any;
  curPath?: string;
}

const block = genBlock("wx-layout");

const Layout: React.FC<RouteComponentProps> = ({ children, match }) => {
  const [isDrawerVisible, setIsDrawerVisible] = React.useState(false);
  const [isLogin, setIsLogin] = React.useState(false);
  const [account, setAccount] = React.useState("");
  const [floatClass, setFloatClass] = React.useState("");
  const [isConfirmVisible, setIsConfirmVisible] = React.useState(true);
  const [customerIncrement, setCustomerIncrement] = React.useState(0);

  const curPathName = useLocation().pathname;

  React.useEffect(() => {
    fetchUserInfo();
    window.addEventListener("scroll", listenScroll);

    return () => {
      window.removeEventListener("scroll", listenScroll);
    };
  }, []);

  function listenScroll() {
    if (document.documentElement.scrollTop > 83) {
      setFloatClass("fixed");
    } else {
      setFloatClass("");
    }

    const clientHeight = document.documentElement.clientHeight,
      scrollTop = document.documentElement.scrollTop,
      scrollHeight = document.documentElement.scrollHeight;

    if (scrollHeight - scrollTop - clientHeight <= 180) {
      setCustomerIncrement(180 - (scrollHeight - scrollTop - clientHeight));
    } else {
      setCustomerIncrement(0);
    }
  }

  function fetchUserInfo() {
    getUserInfo()
      .then((res) => {
        if (res && res.data && res.data.user_id) {
          setIsLogin(true);
          window.sessionStorage.setItem("user_id", res?.data?.user_id);
        } else {
          window.sessionStorage.removeItem("user_id");
          setIsLogin(false);
        }

        if (res && res.data && res.data.username) {
          setAccount(res && res.data && res.data.username);
          window.sessionStorage.setItem(
            "verification_status",
            res?.data?.verification_status
          );
        } else {
          window.sessionStorage.removeItem("verification_status");
        }
      })
      .catch((err) => {
        console.log(err, "err");
        setIsLogin(false);
      });
  }

  function handleLogin() {
    diffEndJump({
      href: URL_LOGIN_PC,
      wapHref: URL_LOGIN_WAP,
      isOpenNewWindow: false,
    });
  }

  function handleRegister() {
    diffEndJump({
      href: URL_REGISTER_PC,
      wapHref: URL_REGISTER_WAP,
      isOpenNewWindow: false,
    });
  }

  function handleLogout() {
    diffEndJump({
      href: URL_LOGOUT_PC,
      wapHref: URL_LOGOUT_WAP,
      isOpenNewWindow: false,
    });
  }

  const drawerHeader = (
    <div className={block("drawer-header")}>
      <KzLogo />
    </div>
  );

  return children ? (
    <div className={block()}>
      <LayoutHeader className={`${block("header")} ${floatClass}`}>
        <div className={block("left")}>
          <KzLogo />
          <LinksNav
            navLinks={wxOtherLinkData}
            currentLink={curPathName}
            className={block("nav")}
          />
        </div>
        <div className={block("right")}>
          {isLogin ? (
            <div className={"user-info"}>
              <span className="info-unit">你好{`, ${account}`}</span>
              <a className="info-unit" href="/v3/weixin/list">
                进入后台
              </a>
              <span className="info-unit" onClick={handleLogout}>
                退出
              </span>
            </div>
          ) : (
            <div className="login-buttons">
              <Button
                className="login-btn"
                themeColor="#198ED9"
                onClick={handleLogin}
              >
                登录
              </Button>
              <Button
                className="register-btn"
                type="primary"
                themeColor="#198ED9"
                onClick={handleRegister}
              >
                立即注册
              </Button>
            </div>
          )}
          <div
            className="wap-menu"
            onClick={() => setIsDrawerVisible((visible) => !visible)}
          >
            <div className="short-line" />
            <div className="long-line" />
            <div className="short-line" />
          </div>
        </div>
      </LayoutHeader>
      {children}
      <Drawer
        visible={isDrawerVisible}
        title={drawerHeader}
        onClose={() => setIsDrawerVisible(false)}
        className={block("drawer")}
        style={{ top: "50px" }}
      >
        {wxOtherLinkData.map((item, index) => (
          <a className="drawer-link" href={item.link} key={index}>
            {item.title}
          </a>
        ))}
        {isLogin ? (
          <Button
            className="login-out-btn"
            themeColor="#188ED8"
            onClick={handleLogout}
          >
            退出登录
          </Button>
        ) : (
          ""
        )}
      </Drawer>

      {curPathName === '/wx/mass-price' ? null :
        <>
            <Dialog
                hide={isConfirmVisible}
                title="联系我们"
                className={block("dialog")}
                actions={[]}
                onClose={() => setIsConfirmVisible(true)}
            >
                <div className={block("dialog-content")}>
                <div className={block("dialog-content-left")}>
                    <p>商务合作：</p>
                    <div>
                    <p>suyuchun@icloudfuture.com</p>
                    <p>免费客服热线</p>
                    <p>400-106-0025</p>
                    <p>周一至周五 9:30-18:30</p>
                    <p>地址：北京市海淀区世纪科贸大厦B座</p>
                    </div>
                </div>
                <div
                    className={`${block("dialog-content-line")} ${block(
                    "dialog-content-line",
                    "left"
                    )}`}
                ></div>
                <div className={block("dialog-content-center")}>
                    <p>客服人员：</p>
                    <img src={CustomerServiceLeft} alt="" />
                </div>
                <div
                    className={`${block("dialog-content-line")} ${block(
                    "dialog-content-line",
                    "right"
                    )}`}
                ></div>
                <div className={block("dialog-content-right")}>
                    <p>客服人员：</p>
                    <img src={CustomerServiceRight} alt="" />
                </div>
                </div>
            </Dialog>

            <div
                style={{ bottom: `calc(25% + ${customerIncrement}px)` }}
                className={block("online-customer")}
            >
                <img
                className={block("online-customer-img")}
                src={hsyQrcodeImg}
                alt=""
                onClick={() => setIsConfirmVisible(false)}
                />
                <p className={block("online-customer-text")}>联系客服</p>
            </div>
        </>
        }
    </div>
  ) : null;
};

export const WxLayout = withRouter(Layout);
